export function formatMB(
  bytes: number,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = minimumFractionDigits,
) {
  return new Intl.NumberFormat('en-US', {
    style: 'unit',
    unit: 'megabyte',
    unitDisplay: 'short',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(bytes / 1024 / 1024);
}
